import React from "react";
import "./Footer.css";
import productsPdf from "../assets/products.pdf";
import toolsPdf from "../assets/tools.pdf";

function Footer() {
  return (
    <>
      {/* ═══════════════════════════════════════
          CONTACT / FOOTER CONTACT SECTION
      ════════════════════════════════════════ */}
      <section className="footer-contact">
        <div className="footer-contact-inner">

          {/* LEFT */}
          <div className="footer-contact-left">
            <p className="footer-tag">Get in Touch</p>

            <h2 className="footer-heading">
              We're Here<br />to Help You
            </h2>

            <div className="footer-contact-items">

              <div className="footer-ci">
                <div className="footer-ci-icon">📍</div>
                <div className="footer-ci-text">
                  <span className="footer-ci-label">Address</span>
                  <p>8-2-103/10, LB Nagar</p>
                  <p>Hyderabad, Telangana – 500074</p>
                </div>
              </div>

              <div className="footer-ci">
                <div className="footer-ci-icon">📞</div>
                <div className="footer-ci-text">
                  <span className="footer-ci-label">Phone</span>
                  <a href="tel:+919030238659">+91 9030238659</a>
                </div>
              </div>

              <div className="footer-ci">
                <div className="footer-ci-icon">📧</div>
                <div className="footer-ci-text">
                  <span className="footer-ci-label">Email</span>
                  <a href="mailto:sales@cleanwaveessentials.in">
                    sales@cleanwaveessentials.in
                  </a>
                </div>
              </div>

            </div>

            <a
              href="https://wa.me/919030238659?text=Hello%20I%20am%20interested%20in%20your%20products"
              className="footer-wa-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.118 1.535 5.845L.057 23.494a.5.5 0 0 0 .613.612l5.701-1.461A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.95 9.95 0 0 1-5.127-1.42l-.36-.214-3.742.96.995-3.653-.237-.376A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
              </svg>
              Chat on WhatsApp
            </a>
          </div>

          {/* RIGHT — MAP */}
          <div className="footer-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3808.5774536448052!2d78.5530601!3d17.335924900000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcba3002a8de467%3A0xffd23b7c50bd49bb!2sCleanwave%20Essentials!5e0!3m2!1sen!2sin"
              title="Cleanwave Location"
              loading="lazy"
              allowFullScreen
            />
          </div>

        </div>
      </section>

      {/* ═══════════════════════════════════════
          FOOTER BOTTOM BAR
      ════════════════════════════════════════ */}
      <footer className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>© 2026 Cleanwave Essentials. All rights reserved.</p>
          <div className="footer-bottom-links">

  <a href="/privacy-policy">
    Privacy Policy
  </a>

  <span>|</span>

  <a href="/terms-conditions">
    Terms & Conditions
  </a>

</div>
        </div>
      </footer>

      {/* ═══════════════════════════════════════
          FLOATING SOCIAL STACK
      ════════════════════════════════════════ */}
      <div className="social-float">

        <a
          href="https://wa.me/919030238659"
          className="sf-btn whatsapp"
          data-tip="WhatsApp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
            alt="WhatsApp"
          />
          <span className="sf-ring"></span>
        </a>

        <a
          href="https://www.instagram.com/cleanwaveessentials"
          className="sf-btn instagram"
          data-tip="Instagram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
            alt="Instagram"
          />
        </a>

        <a
          href="https://www.facebook.com/andojuharishkumarchary/"
          className="sf-btn facebook"
          data-tip="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
            alt="Facebook"
          />
        </a>

{/* PRODUCTS BROCHURE */}
<div className="brochure-item">
  <span className="brochure-side-text">
    PRODUCTS
  </span>

  <button
    type="button"
    onClick={() => {
      const link = document.createElement("a");
      link.href = productsPdf;
      link.download = "products-brochure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }}
    className="sf-btn brochure"
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/724/724933.png"
      alt="Products Brochure"
    />
  </button>
</div>

{/* TOOLS BROCHURE */}
<div className="brochure-item">
  <span className="brochure-side-text">
    TOOLS
  </span>

  <button
    type="button"
    onClick={() => {
      const link = document.createElement("a");
      link.href = toolsPdf;
      link.download = "tools-brochure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }}
    className="sf-btn brochure tools-btn"
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/724/724933.png"
      alt="Tools Brochure"
    />
  </button>
</div>

      </div>
    </>
  );
}

export default Footer;